import { Button, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { AssignmentSelectStrategyTable } from 'packages/loanProduct/ui/assignmentStrategy/AssignmentSelectStrategyContainer';
import { FiPlus } from 'react-icons/fi';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { SettingsViewTemplate } from '~/core/routes/settings/SettingsTemplate';

import 'source/borrower/borrower.scss';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const navigate = useNavigate();

  return (
    <>
      <Text fontSize="lg" mb="32px" color="gray">
        Set a strategy as the default for future proposals, view a summary,
        initiate an assignment run using a strategy, or modify an existing
        strategy.
      </Text>
      <Flex justifyContent="flex-start" mb="32px">
        <Button
          size="md"
          aria-label="create new strategy"
          leftIcon={<FiPlus />}
          width="fit-content"
          onClick={() => navigate(`/settings/assignment-strategy/new`)}
          variant="outline"
          colorScheme="aurora"
          borderWidth="2px"
        >
          Create New Strategy
        </Button>
      </Flex>
      <AssignmentSelectStrategyTable
        organizationId={user.organizationId}
        editable
      />
    </>
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings" />;
      }}
    >
      <SettingsViewTemplate>
        <RouteBase />
      </SettingsViewTemplate>
    </RouteErrorBoundary>
  );
};
